import styled from 'styled-components';

export const Container = styled.footer`
  display: flex;
  align-items: center;
  height: 72px;
  padding: 0 20px;
  background: #000;

  p {
    width: 1282px;
    max-width: 1282px;
    margin: 0 auto;
    font-family: 'Verdana', sans-serif;
    font-weight: 700;
    color: #fff;
  }
`;
